module.exports = {"210283001":"城关街道","210283002":"新华街道","210283003":"兴达街道","210283004":"昌盛街道","210283005":"明阳街道","210283101":"青堆镇","210283102":"徐岭镇","210283104":"黑岛镇","210283105":"栗子房镇","210283107":"大营镇","210283108":"塔岭镇","210283109":"仙人洞镇","210283110":"蓉花山镇","210283111":"长岭镇","210283112":"荷花山镇","210283113":"城山镇","210283114":"光明山镇","210283115":"大郑镇","210283118":"吴炉镇","210283120":"王家镇","210283204":"鞍子山乡","210283208":"太平岭满族乡","210283209":"步云山乡","210283211":"桂云花满族乡","210283214":"兰店乡","210283216":"石城乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210283.json
// module id = 612
// module chunks = 0